/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertConfigRequestBody2,
  UpsertConfigRequestBody2$Outbound,
  UpsertConfigRequestBody2$outboundSchema,
} from "../components/upsertconfigrequestbody2.js";

export type UpsertDeviceIntegrationConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpsertDeviceIntegrationConfigRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  upsertConfigRequestBody2: UpsertConfigRequestBody2;
};

/** @internal */
export type UpsertDeviceIntegrationConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpsertDeviceIntegrationConfigSecurity$outboundSchema:
  z.ZodMiniType<
    UpsertDeviceIntegrationConfigSecurity$Outbound,
    UpsertDeviceIntegrationConfigSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function upsertDeviceIntegrationConfigSecurityToJSON(
  upsertDeviceIntegrationConfigSecurity: UpsertDeviceIntegrationConfigSecurity,
): string {
  return JSON.stringify(
    UpsertDeviceIntegrationConfigSecurity$outboundSchema.parse(
      upsertDeviceIntegrationConfigSecurity,
    ),
  );
}

/** @internal */
export type UpsertDeviceIntegrationConfigRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  UpsertConfigRequestBody2: UpsertConfigRequestBody2$Outbound;
};

/** @internal */
export const UpsertDeviceIntegrationConfigRequest$outboundSchema: z.ZodMiniType<
  UpsertDeviceIntegrationConfigRequest$Outbound,
  UpsertDeviceIntegrationConfigRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    upsertConfigRequestBody2: UpsertConfigRequestBody2$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      upsertConfigRequestBody2: "UpsertConfigRequestBody2",
    });
  }),
);

export function upsertDeviceIntegrationConfigRequestToJSON(
  upsertDeviceIntegrationConfigRequest: UpsertDeviceIntegrationConfigRequest,
): string {
  return JSON.stringify(
    UpsertDeviceIntegrationConfigRequest$outboundSchema.parse(
      upsertDeviceIntegrationConfigRequest,
    ),
  );
}
